import { render, staticRenderFns } from "./IrrigationControlConfig.vue?vue&type=template&id=6b56c2ae&scoped=true"
import script from "./IrrigationControlConfig.vue?vue&type=script&lang=js"
export * from "./IrrigationControlConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56c2ae",
  null
  
)

export default component.exports